
export const TIPS_LOADED = '@tips/TIPS_LOADED';
export const TIPS_CLEARED = '@tips/TIPS_CLEARED';